var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1300 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #fa9378;\n      }\n\n      .cls-4 {\n        fill: #f3ecf1;\n      }\n\n      .cls-5 {\n        fill: #f5e2da;\n      }\n\n      .cls-6 {\n        fill: #fbd5a2;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #a19c9f;\n      }\n\n      .cls-9 {\n        fill: #d9d3d7;\n      }\n\n      .cls-10 {\n        fill: #c7b0a7;\n      }\n\n      .cls-11 {\n        fill: #c94660;\n      }\n\n      .cls-12 {\n        fill: #29190f;\n      }\n\n      .cls-2 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-13 {\n        fill: url(#Unbenannter_Verlauf_2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    "data-name": "Unbenannter Verlauf 2",
    x1: 650,
    y1: 1345.39,
    x2: 650,
    y2: 177.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f9ed32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9edb4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1300,77.54v844.91c0,42.82-34.54,77.54-77.13,77.54H77.13c-42.6,0-77.13-34.72-77.13-77.54V77.54C0,34.72,34.54,0,77.13,0h1145.74c42.6,0,77.13,34.72,77.13,77.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m93.72,104.99h71.8c9.53,0,17.26-7.77,17.26-17.35h0c0-9.58-7.73-17.35-17.26-17.35h-71.8c-9.53,0-17.26,7.77-17.26,17.35h0c0,9.58,7.73,17.35,17.26,17.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1186.21,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1129.36,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1072.51,
    cy: 87.64,
    rx: 17.26,
    ry: 17.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 711.37,
    cy: 118.57,
    rx: 42.9,
    ry: 95.58,
    transform: "translate(359.58 748.14) rotate(-70.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "717.1 278.67 585 221.96 639.84 96.62 771.95 153.32 717.1 278.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m304.25,611.63c16.13,28.46,52.07,38.46,80.48,22.34l197.96-113.06,45.21-25.74c19.13-10.98,29.85-31.08,29.85-51.77,0-9.91-2.42-19.91-7.63-29.14-16.13-28.46-52.17-38.46-80.48-22.34l-72.27,41.18-170.91,97.62c-28.4,16.22-38.26,52.45-22.22,80.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 361.65,
    cy: 586.91,
    rx: 76.02,
    ry: 76.42
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "501.07 860.65 457.03 789.04 537.12 739.26 581.16 810.87 501.07 860.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m584.69,861.68l-49.76-80.91,20.05-12.46,49.76,80.91c3.42,5.57,1.71,12.87-3.83,16.31h0c-5.54,3.44-12.8,1.72-16.22-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m571.08,884.62l-49.76-80.91,20.05-12.46,49.76,80.91c3.42,5.57,1.71,12.87-3.83,16.31h0c-5.54,3.44-12.8,1.72-16.22-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m546.53,889.75l-49.76-80.91,20.05-12.46,49.76,80.91c3.42,5.57,1.71,12.87-3.83,16.31h0c-5.54,3.44-12.8,1.72-16.22-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m516.49,885.97l-49.76-80.91,20.05-12.46,49.76,80.91c3.42,5.57,1.71,12.87-3.83,16.31h0c-5.54,3.44-12.8,1.72-16.22-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m327.65,540.6h0c27.72-17.23,64.09-8.61,81.23,19.26l128.24,179.39-83.64,51.99-144.99-168.98c-17.14-27.87-8.56-64.43,19.16-81.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "583.03 862.71 586.35 860.64 560.03 817.85 556.71 819.92 583.03 862.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "565.65 879.81 568.97 877.76 538.75 828.31 535.43 830.36 565.65 879.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "534.89 874.54 538.21 872.48 518.7 840.77 515.38 842.84 534.89 874.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m697.9,750.22l-.77,16.71-10.92,233.07h-210.93c3.73-42.49,8.73-83.58,15.38-121.84,1.13-6.57,2.34-13.07,3.58-19.5.15-.73.29-1.51.44-2.24.29-1.51.58-3.01.88-4.48.04-.07.04-.15.04-.18.04-.07.04-.15.07-.22.88-4.41,1.79-8.78,2.7-13.11,1.24-5.69,2.52-11.31,3.87-16.86.11-.48.22-.99.37-1.47.07-.44.18-.88.29-1.29.15-.62.29-1.21.47-1.84.26-1.06.51-2.13.77-3.19.99-3.86,1.97-7.64,2.96-11.38,1.61-5.95,3.29-11.79,5-17.48.04-.04.04-.07.04-.07v-.04c3.69-12.15,7.63-23.72,11.87-34.59h173.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m869.46,1000h-222.37l-7.41-76.12-15.12-156.1-1.72-17.55h156.62s.11.22.36.62c1.21,2.09,5.84,10.1,12.38,22.47,4.16,7.86,9.06,17.41,14.35,28.35,13.33,27.54,29.15,63.67,41.38,102.12,4.05,12.6,7.67,25.48,10.74,38.37.26,1.1.51,2.17.77,3.27.04.15.07.33.11.48,3.03,13.29,5.81,28.13,8.36,44.1.51,3.3,1.02,6.61,1.53,9.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "642.56 924.65 649.94 1000 643.51 1000 636.61 929.75 590 917.41 591.61 911.17 639.68 923.88 642.56 924.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m852.44,1000h-6.54c-.58-4.08-1.24-8.08-1.94-12.04-2.63-15.53-5.7-30.26-9.06-44.18-3.62-14.95-7.6-28.97-11.8-42.12-7.16-22.4-14.98-42.27-22.83-59.64v-.04c-2.3-5.07-4.6-9.84-6.9-14.5-15.74-31.95-31.01-54.13-40.95-66.94-3.62-4.66-6.5-8.12-8.47-10.32-.4-.48-.77-.92-1.1-1.25-.18-.22-.33-.4-.51-.55-.73-.81-1.13-1.25-1.21-1.32l4.53-4.55c.15.15,2.04,2.13,5.33,5.99.07.15.22.29.36.44.29.4.66.81,1.02,1.25,1.97,2.39,4.31,5.32,6.98,8.81.29.4.62.84.91,1.29,7.45,9.95,17.09,24.09,27.43,42.63v.04c.66,1.14,1.28,2.24,1.94,3.42,4.05,7.42,8.22,15.5,12.38,24.27,9.64,20.23,19.32,44.07,27.94,71.57,3.87,12.23,7.52,25.23,10.85,38.92,3.65,14.91,6.94,30.66,9.75,47.33.47,2.9.95,5.84,1.42,8.81.15.88.29,1.8.44,2.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 656.75,
    cy: 291.14,
    rx: 99.41,
    ry: 67.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 645.76,
    cy: 247.52,
    rx: 65.61,
    ry: 65.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m664.54,317.55l-40.29,12.32c-30.12,6.18-57.01-20.02-51.8-50.48l9.72-48.2,91.25-3.1-8.88,89.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m623.31,238.21c2.32.15,5.72.65,6.5,3.23.81,2.67-2.6,4-4.2,2.4-.71-.35-1.54-.53-2.3-.58-3.22-.21-3.24-5.26,0-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m593.06,237.01c2.32.15,5.72.65,6.5,3.23.81,2.67-2.6,4-4.2,2.4-.71-.35-1.54-.53-2.3-.58-3.22-.21-3.24-5.26,0-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m673.98,377.76h-34.46c-9.44,0-17.09-7.69-17.09-17.18h0c0-9.49,7.65-17.18,17.09-17.18h34.46c9.44,0,17.09,7.69,17.09,17.18h0c0,9.49-7.65,17.18-17.09,17.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "717.23 377.76 653.46 377.76 627.55 265.9 691.32 265.9 717.23 377.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m680.25,283.77s-26.17-14.8-16.91-36.24c9.26-21.45,4.43-40.25,4.43-40.25,0,0-33.56,20.22-46.45,24.69-12.88,4.47-39.15-.77-39.15-.77,0,0,.09-58.4,58.91-61.96,46.81-2.83,96.32,32.78,76.14,90.6-15.34,43.93-36.98,23.94-36.98,23.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 701.24,
    cy: 275.99,
    rx: 27.12,
    ry: 19.53,
    transform: "translate(22.16 602.72) rotate(-47.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m696.68,275.59l-3.08-2.24c8.1-11.25,20.03-10.49,20.54-10.45l-.28,3.81c-.41-.03-10.35-.6-17.18,8.88Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "641.69 326.53 640.51 322.91 655.56 317.92 656.75 321.55 641.69 326.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m604.19,295.13c-3.37,0-5.88-.3-6.04-.32l.46-3.79s5.45.65,10.82,0c5.21-.63,10.45-3.85,10.5-3.88l1.99,3.25c-.24.15-6.02,3.69-12.05,4.42-1.99.24-3.95.32-5.69.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m598.73,277.03c-1.16-1.78-3.8-6.21-3.22-8.76.17-.74.64-1.38,1.32-1.79,1.57-.94,4.52-.59,6.75-.13l1.06-6.52,3.75.61-1.73,10.66-2.04-.57c-1.97-.55-4.21-.88-5.32-.84.3,1.15,1.39,3.37,2.61,5.25l-3.18,2.09Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 624.37,
    cy: 257.94,
    rx: 3.05,
    ry: 5.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 595.1,
    cy: 257.94,
    rx: 3.05,
    ry: 5.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m693.13,301.99c-.86,0-1.73-.06-2.58-.2l.62-3.77c3.24.54,7.33-.57,7.36-.58l1.02,3.68c-.16.04-3.15.87-6.42.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m451.9,1000c6.35-58.68,18.01-106.05,29.4-141.27,2.01-6.28,4.05-12.19,6.03-17.7.11-.33.22-.62.33-.92.07-.22.18-.44.22-.66.04-.07.07-.11.07-.15.48-1.29.95-2.53,1.39-3.78,1.28-3.42,2.56-6.68,3.76-9.77,1.9-4.7,3.69-9.03,5.37-12.93.11-.22.22-.48.29-.7l.04-.04c.04-.15.11-.26.18-.4.36-.84.69-1.65,1.06-2.42.26-.59.47-1.14.73-1.65.26-.62.55-1.18.8-1.76,5.99-13.15,10.08-20.2,10.52-20.93.04-.04.04-.07.04-.07v-.04c-.07-.99-1.17-16.05,3.11-24.2,2.45-4.63,5.95-8.85,8.62-11.71.04-.04.07-.07.15-.11v-.04c2.12-2.24,3.65-3.6,3.65-3.6l13.22.18,201.48,3.08,8.66.11,17.68.29,10.77.15h.04l.33,1.87,8.51,48.1,1.31,7.45,3.73,21.08,4.86,27.5,7.78,43.92v1.25l.15,16.82.15,17.52.15,14.95.26,30.04.04,5.25.11,10.14v.29l.04,4.85h-354.99Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 651.74,
    cy: 748.29,
    rx: 127.8,
    ry: 19.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m500.27,587.45c5.89,12.53,9.47,26.13,10.63,39.92l-10.87,80.27c-1.98,14.65,4.72,29.12,17.15,37.03l6.77,4.31h255.54l8.5-11.37c8.86-11.85,12.23-26.97,9.23-41.48l-12.8-62.05,7.25-167.26,1.16-26.03c.77-19.04-6.18-36.42-17.97-49.44-12.56-14.08-30.92-22.92-51.3-22.92h-97.58c-25.51,0-41.25,13.6-61.06,36.72l-60.29,76.25-1.64,2.14c-17.2,32.25-18.26,70.81-2.7,103.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m682,441.26c0,10,2.51,20.2,7.83,29.53l6.86,11.85,87.72,152.69,45.41,78.87c16.33,28.36,52.36,38.07,80.58,21.66,28.21-16.32,37.87-52.64,21.64-81.01l-119.12-207.18-20.87-36.23c-4.44-7.77-10.34-14.08-17.2-18.84-18.26-12.92-42.9-14.76-63.38-2.82-18.94,10.98-29.47,30.89-29.47,51.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 883.75,
    cy: 661.49,
    rx: 71.08,
    ry: 71.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m795.77,982.55l16.31-50.55c2.15-6.67-1.48-13.83-8.11-15.99h0c-6.63-2.16-13.75,1.49-15.91,8.16l-16.31,50.55c-2.15,6.67,1.48,13.83,8.11,15.99h0c6.63,2.16,13.75-1.49,15.91-8.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 792.63,
    y: 897.82,
    width: 84.19,
    height: 94.16,
    transform: "translate(-177.93 1695.98) rotate(-85.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "811.97 934.97 808.13 979.58 807.69 984.8 806.85 994.86 806.42 1000 782.75 1000 783.51 991.33 784.24 982.78 788.52 932.91 806.31 934.49 811.13 934.89 811.97 934.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "834.43 949.25 833.41 961.3 831.84 979.29 831.22 986.85 830.08 1000 806.42 1000 806.85 995.15 806.85 994.86 807.73 984.8 808.17 979.62 810.94 947.23 834.43 949.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "858.65 942.71 855.36 981.35 855.32 981.35 854.7 988.87 853.75 1000 830.08 1000 831.22 986.85 831.84 979.29 831.87 979.29 833.41 961.3 834.43 949.25 834.91 943.78 835.16 940.66 840.82 941.17 858.61 942.71 858.65 942.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "883.74 925.71 877.38 1000 853.72 1000 854.67 988.87 855.32 981.35 858.61 942.71 858.68 942.16 860.25 923.69 861.28 923.77 883.63 925.71 883.74 925.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m889.25,626.62h0c-32.47-2.81-61.06,21.38-63.86,54.02l-33.98,218.26,93.81,8.12,57.76-216.2c2.8-32.65-21.26-61.39-53.73-64.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "810.1 979.77 809.67 984.98 808.39 1000 804.48 1000 805.79 984.65 806.23 979.44 808.13 979.58 808.17 979.62 810.1 979.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "833.77 979.44 833.15 987 832.06 1000 828.19 1000 829.28 986.67 829.9 979.14 831.84 979.29 831.87 979.29 833.77 979.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "857.26 981.49 856.6 989.02 856.6 989.06 855.69 1000 851.78 1000 852 997.32 852.73 988.69 853.39 981.16 855.32 981.35 855.36 981.35 856.6 981.42 857.26 981.49"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "784.62 640.7 789.92 637.76 755.98 576.1 750.68 579.04 784.62 640.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m537.3,843.31l-32.31-75.01-21.56,9.58,32.31,75.01c2.63,5.99,9.59,8.69,15.54,6.05h0c5.95-2.64,8.65-9.64,6.02-15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m509.16,864.49l-35.55-85.75-20.13,12.51,34.05,82.67c2.59,6,9.53,8.76,15.5,6.16h0c5.97-2.6,8.71-9.58,6.12-15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m526.63,870.99l-32.31-75.01-21.56,9.58,32.31,75.01c2.63,5.99,9.59,8.69,15.54,6.05h0c5.95-2.64,8.65-9.64,6.02-15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m515.23,869.27c-2.15,0-4.09.99-5.41,2.57-.44.48-.77,1.03-1.06,1.62-.4.77-.66,1.62-.77,2.5-.04.33-.07.66-.07,1.03,0,4.26,3.29,7.71,7.31,7.71.15,0,.29,0,.44-.04,3.83-.22,6.83-3.56,6.83-7.67s-3.25-7.71-7.27-7.71Zm0,13.04c-.37,0-.73-.04-1.1-.15-2.19-.51-3.84-2.64-3.84-5.18,0-.29.04-.59.11-.88.36-2.53,2.41-4.44,4.82-4.44,2.7,0,4.89,2.39,4.89,5.32s-2.19,5.32-4.89,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m530.83,842.17c-1.17-.81-2.56-1.29-4.02-1.29-2.48,0-4.67,1.32-5.99,3.34-.44.62-.77,1.36-.99,2.09v.04c-.22.73-.33,1.51-.33,2.28,0,.18,0,.33.04.51v.04c0,.18,0,.33.04.48v.04c.18,1.51.8,2.86,1.68,3.93l.04.04c.47.59,1.02,1.1,1.64,1.51h.04c.88.59,1.86.99,2.96,1.1.29.04.58.07.88.07.48,0,.95-.04,1.39-.15,3.36-.7,5.88-3.86,5.88-7.56,0-2.68-1.32-5.07-3.25-6.46Zm-4.02,11.79c-1.1,0-2.12-.4-2.96-1.1l-.04-.04c-.88-.66-1.5-1.65-1.75-2.83v-.04c-.11-.4-.18-.84-.18-1.32,0-.33.04-.66.11-.99.04-.37.15-.73.29-1.07.69-1.95,2.45-3.3,4.53-3.3.58,0,1.17.11,1.68.33,1.86.73,3.21,2.72,3.21,5.03,0,2.94-2.19,5.32-4.89,5.32Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.09 858.44 522.68 856.88 501.35 807.37 497.77 808.93 519.09 858.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "501.83 877.99 505.47 876.55 487.52 830.87 483.9 832.32 501.83 877.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m490.94,572.31l5.89-1.37c-.09-.42-9.52-42.41-.12-67.14,9.48-24.93,43.3-56,43.64-56.31l-4.08-4.5c-1.42,1.31-35.21,32.35-45.21,58.65-10.06,26.46-.53,68.87-.11,70.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "598.95 979.73 605.42 976.52 570.7 910.98 564.23 914.19 598.95 979.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "590.8 1000 582.88 1000 576.93 986.74 583.9 984.72 590.8 1000"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m717.85,377.76h-34.46c-9.44,0-17.09-7.69-17.09-17.18h0c0-9.49,7.65-17.18,17.09-17.18h34.46c9.44,0,17.09,7.69,17.09,17.18h0c0,9.49-7.65,17.18-17.09,17.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 666.3,
    y: 487.77,
    width: 51.93,
    height: 15.95
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 657.53,
    cy: 405.88,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 640.27,
    cy: 446.76,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 630.85,
    cy: 493.62,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 630.85,
    cy: 551.06,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 630.85,
    cy: 608.5,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 630.85,
    cy: 665.94,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 630.85,
    cy: 723.38,
    rx: 6.28,
    ry: 6.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 599.77,
    cy: 405.88,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 582.51,
    cy: 446.76,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 573.09,
    cy: 493.62,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 573.09,
    cy: 551.06,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 573.09,
    cy: 608.5,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 573.09,
    cy: 665.94,
    rx: 6.28,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 573.09,
    cy: 723.38,
    rx: 6.28,
    ry: 6.31
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m567.08,267.01l1.34-6.82c-3.13,4.11-5.66,8.47-7.51,13.02,1.9-2.15,3.95-4.22,6.17-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m760.26,760.38l.32,1.84c1.92,3.39,12.55,22.34,25.69,50.23l5.93-39.13c-6.53-12.37-11.16-20.39-12.39-22.49l-.33-1.86,8.5-11.37c6.55-8.76,10.09-19.31,10.28-30.09l-30.97-55.29-1.1.63,11.1,55.32c2.88,14.34-.35,29.27-8.87,40.98l-8.17,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m708.56,97.7c45.83,16.85,77.65,47.1,73.44,69.02,9.85-3.2,16.75-8.54,19.37-15.95,7.9-22.33-25.98-54.85-75.68-72.63-49.7-17.78-96.4-14.09-104.31,8.24-.74,2.09-1.1,4.28-1.12,6.53,18.01-9.63,52.33-8.44,88.3,4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m588.37,204.18c.08-.08.15-.16.22-.24l1.12-2.63c-.48.96-.93,1.92-1.35,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m746.03,188.39l-32.16,75.54c14.91,11.77,23.97,27.23,23.97,44.18,0,11.09-3.91,21.53-10.76,30.73,17.96-12.22,29.08-29.08,29.08-47.71,0-17.16-9.43-32.81-24.94-44.72l26.14-59.73c-3.5.81-7.28,1.38-11.32,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m954.82,661.5c0,1.25-.04,2.46-.11,3.67-.04.99-.11,1.98-.22,2.97-.04.48-.07.95-.15,1.43,0,.18,0,.37-.04.55-.07.48-.11.92-.18,1.4-.07.55-.15,1.1-.26,1.65-.11.77-.26,1.51-.44,2.24,0,.15-.04.26-.07.4-.11.73-.29,1.51-.47,2.24-.15.66-.29,1.32-.48,1.98-.26.92-.51,1.8-.8,2.72-.29.99-.62,1.98-.99,2.97-.47,1.29-.95,2.53-1.5,3.78-.04.11-.11.26-.15.37-.26.59-.51,1.18-.8,1.76-.07.15-.15.33-.22.48-.29.66-.62,1.36-.99,2.06-.04.07-.07.11-.11.18-.04.04-.04.07-.07.11-.4.81-.88,1.62-1.31,2.42-.59,1.1-1.24,2.13-1.9,3.19-.11.18-.22.33-.37.51-.26.48-.58.95-.91,1.4-1.13,1.65-2.3,3.23-3.58,4.77v.07l-53.47,200.17-1.61,18.69h.11l-6.36,74.29h-22.35l.95-11.02.62-7.56,2.96-35.51.91-10.94h-.11l.91-11.2.62-7.27,2.92-11.24,43.76-168.4,2.41-9.33,2.3-8.81c9.68-12.19,15.49-27.76,15.49-44.76,0-13.11-3.47-25.37-9.5-35.91-10.12-17.63-27.39-30.29-47.7-33.75l-6.57-11.75-72.61-129.81-.51-.92-19.54-34.85c-3.65-6.57-8.36-12.12-13.77-16.52-.88-1.14-1.79-2.28-2.78-3.34-9.28-10.72-21.92-18.32-36.12-21.26h-.04c-1.42-.33-2.85-.59-4.31-.77,1.21-2.17,1.94-4.66,2.05-7.31.07-.33.07-.7.07-1.06,0-3.01-.77-5.84-2.08-8.26-.15-.29-.33-.59-.47-.84,0,0,0-.04-.04-.04-2.67-4.22-7.05-7.2-12.16-7.75,3.18-1.8,6.21-3.78,9.02-5.88,4.09-3.01,7.78-6.28,11.03-9.8.37.11.73.22,1.06.37.44.15.84.33,1.28.55.37.15.73.33,1.1.55.37.18.69.37,1.02.62.4.26.8.51,1.17.84.47.37.91.73,1.31,1.14.22.18.44.4.62.62.44.44.8.92,1.17,1.4.26.37.55.73.77,1.1.29.44.58.92.8,1.43.22.37.4.73.55,1.14.18.4.33.81.48,1.25.15.37.26.77.33,1.18.18.59.29,1.18.37,1.8.07.33.11.66.11,1.03.04.48.07.95.07,1.43,0,.44,0,.88-.07,1.32,0,.29-.04.59-.07.88-.07.55-.15,1.07-.29,1.62-.07.44-.22.92-.36,1.36-.11.37-.22.73-.4,1.1-.11.33-.22.62-.37.92-.18.44-.4.88-.66,1.29,1.21.15,2.41.37,3.58.59.88.15,1.75.33,2.59.51,1.64.37,3.25.81,4.86,1.29.73.22,1.46.44,2.19.7.99.33,1.94.7,2.88,1.07.15.04.26.11.4.15.77.29,1.5.62,2.23.95.59.26,1.17.51,1.75.81.11.07.26.11.37.18.84.4,1.64.81,2.45,1.25.88.44,1.68.92,2.52,1.4.8.44,1.57.92,2.3,1.43,1.28.81,2.48,1.65,3.69,2.53.91.66,1.79,1.36,2.67,2.09.66.51,1.32,1.06,1.94,1.65.51.4.99.88,1.46,1.32,1.5,1.4,2.92,2.86,4.27,4.37.99,1.1,1.94,2.24,2.85,3.38l.04.04s.07.07.11.07c1.39,1.14,2.78,2.31,4.05,3.6.69.62,1.35,1.29,1.97,1.98.55.55,1.06,1.14,1.57,1.73.11.11.22.26.33.37.04.07.11.11.15.18.47.55.95,1.14,1.39,1.73.66.81,1.28,1.65,1.86,2.53.37.48.73.99,1.06,1.51.62.95,1.24,1.95,1.83,2.97l20.86,36.24,82.4,143.29c.15.04.29.04.44.07.77.11,1.53.26,2.3.44.51.11,1.02.22,1.5.33t.07.04c.84.15,1.64.37,2.45.59.84.22,1.68.48,2.52.73.99.29,1.97.62,2.96.99.99.33,1.97.7,2.92,1.1.99.4,1.94.81,2.85,1.25.95.44,1.9.88,2.81,1.36,1.83.95,3.62,1.98,5.37,3.08.88.55,1.72,1.1,2.56,1.69.84.59,1.68,1.21,2.48,1.84,1.64,1.25,3.21,2.53,4.75,3.93.77.66,1.5,1.4,2.23,2.09.37.33.73.7,1.06,1.06.15.15.26.26.4.4.95.99,1.86,2.02,2.74,3.05.66.77,1.32,1.58,1.94,2.39.77.99,1.53,1.98,2.23,3.01.44.62.88,1.21,1.28,1.87.04,0,.04.04.04.04,1.72,2.61,3.25,5.36,4.6,8.19.51,1.03.99,2.09,1.42,3.16.44,1.06.88,2.17,1.28,3.27.4,1.06.77,2.17,1.1,3.3.29.92.55,1.84.8,2.75.11.48.26.88.33,1.32.04.07.07.18.07.26.22.84.4,1.69.55,2.53.18.81.33,1.62.48,2.42.11.62.18,1.21.29,1.87.04.29.07.59.11.88.11.7.18,1.4.22,2.13.04.15.04.29.04.44.11.99.18,1.98.22,2.97.07,1.21.11,2.42.11,3.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "493.9 702.72 496.56 682.53 444.36 609.51 433.5 615.88 493.9 702.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m358.7,524.79c.08,0,.15,0,.23,0l130.21-76.44,69.45-40.68c4.02-2.35,8.19-4.12,12.45-5.38,11.95-11.09,24.02-17.4,40.13-17.79-1.17-2.34-1.85-4.99-1.85-7.8,0-2.01.36-3.93.98-5.72-.31-.08-.62-.16-.93-.24-9.82,2.8-18.34,8.13-26.77,15.74-4.43,1.27-8.77,3.06-12.95,5.44l-72.27,41.18-135.48,77.38c-.08,0-.16,0-.24,0-41.98,0-76.02,34.22-76.02,76.42,0,2.27.11,4.51.3,6.73,3.26-38.57,34.58-68.84,72.76-68.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 91.3,
    y: 373.5,
    width: 223.11,
    height: 2.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m297.19,473.96H102.62c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h194.56c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 97.72,
    y: 605.36,
    width: 121.47,
    height: 207.97,
    rx: 26.8,
    ry: 26.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m204.65,512.06h-102.03c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h102.03c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m297.19,295.81H102.62c-3.26,0-5.91-2.66-5.91-5.94h0c0-3.28,2.64-5.94,5.91-5.94h194.56c3.26,0,5.91,2.66,5.91,5.94h0c0,3.28-2.64,5.94-5.91,5.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 96.72,
    y: 322.03,
    width: 113.84,
    height: 11.88,
    rx: 5.94,
    ry: 5.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m201.61,250.61h-94.39c-5.8,0-10.5-4.73-10.5-10.56h0c0-5.83,4.7-10.56,10.5-10.56h94.39c5.8,0,10.5,4.73,10.5,10.56h0c0,5.83-4.7,10.56-10.5,10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m172.48,428.1h-65.26c-5.8,0-10.5-4.73-10.5-10.56h0c0-5.83,4.7-10.56,10.5-10.56h65.26c5.8,0,10.5,4.73,10.5,10.56h0c0,5.83-4.7,10.56-10.5,10.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1054.36,
    y: 393.64,
    width: 164.6,
    height: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1198.19,514.79h-130.18c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h130.18c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1164.94,560.74h-96.92c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h96.92c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1065.8,
    y: 611.84,
    width: 100.26,
    height: 235.94,
    rx: 35.72,
    ry: 35.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1198.19,299.95h-130.18c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h130.18c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1164.94,345.9h-96.92c-3.93,0-7.12-3.21-7.12-7.16h0c0-3.96,3.19-7.16,7.12-7.16h96.92c3.93,0,7.12,3.21,7.12,7.16h0c0,3.96-3.19,7.16-7.12,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1161.27,245.44h-87.71c-6.99,0-12.66-5.7-12.66-12.73h0c0-7.03,5.67-12.73,12.66-12.73h87.71c6.99,0,12.66,5.7,12.66,12.73h0c0,7.03-5.67,12.73-12.66,12.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1060.89,
    y: 434.02,
    width: 77.92,
    height: 25.46,
    rx: 12.73,
    ry: 12.73
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img_5.2f4b3c07f2a0415657f5286dac8640dc.svg";
export { ForwardRef as ReactComponent };